import React, { useState, useEffect } from "react";
// import { photoEquipmentArray } from "../../assets/globalArrays/photoEquipmentArray";
import { photoEquipmentArray } from "../../../assets/globalArrays/photoEquipmentArray";

export default function PhotoEquipment({
  packageShow,
  packageDocReady,
  containerClass,
  iconClass,
  heading,
}) {
  const [photoEquipment, setPhotoEquipment] = useState();
  const [displaySection, setDisplaySection] = useState(false);

  useEffect(() => {
    if (packageDocReady) {
      setPhotoEquipment(packageShow.photoEquipment);
    }
  }, [packageDocReady, packageShow]);

  const display = () => {
    setDisplaySection(!displaySection);
  };

  return (
    <>
      <div className="cursor-pointer">
        <p
          data-cy="package-photoEquipment-heading"
          className={heading}
          onClick={display}
        >
          Photo Equipment
        </p>
        {displaySection && (
          <div className="grid grid-cols-2 md:grid-cols-4 md:gap-4">
            {photoEquipment &&
              photoEquipment.map((item) => {
                const i = photoEquipmentArray().findIndex(
                  (e) => e.value === item
                );
                // const i = 0;
                // console.log("Item: ", item);
                // console.log("i: ", i);
                const icon = photoEquipmentArray(iconClass)[i].icon;
                const title = photoEquipmentArray()[i].title;
                return (
                  <div key={item} className={containerClass}>
                    <span>{icon}</span>
                    <span
                      data-cy="package-photoEquipment-icons"
                      className="capitalize ml-2 text-xs"
                    >
                      {title}
                    </span>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </>
  );
}
